import Module from '../../Module';
import mock from './mock';
import UserService from '../User';
import services from 'core/services';

class AuthService extends Module {
  get baseURL() {
    return '/api/v1/customers'
  }

  initMock(handler) {
    mock(this.handler)
  }

  /**
   * Parse authorized user token
   * @param {Object} token token to parse
   * @return {Object}
   */
  parseToken(token) {
    if (!token) return null

    return {
      payload: token,
      expire: token.expire,
      revoked: token.revoked,
      user: UserService.parseUser(token.user)
    }
  }

  parseClient(customer) {
    return {
      createdAt: customer.createdAt,
      customer_id: customer.customer_id,
      deletedAt: customer.deletedAt,
      device: customer.device ? this.parseDevice(customer.device) : null,
      deviceKey: customer.deviceKey,
      id: customer.id,
      notificationToken: customer.notificationToken,
      updatedAt: customer.updatedAt,
    }
  }

  parseDevice(device) {
    return {
      app_version: device.app_version,
      manufacturer: device.manufacturer,
      model: device.model,
      platform: device.platform,
      serial: device.serial,
      version: device.version,
    }
  }

  /**
   * Login user
   * @param {String} username
   * @param {String} password
   * @return {Promise}
   */
  login(username = '', password = '', remember = true) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}/signin`, {
          data: {
            username: username,
            password: password
          },
          params: {
            errorHandler: true
          }
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              token: this.parseToken(data.token)
            }))
          )
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * Logout user
   * @return {Promise}
   */
  logout() {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/signout`)
        .then(r => {
          resolve(r)
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * Authorize user token
   * @return {Promise}
   */
  authorize() {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/authorize`)
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              user: UserService.parseUser(data.user)
            }))
          )
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * Reset current user password
   * @param {String} oldPass old password
   * @param {String} newPass new password
   */
  resetPassword(oldPass, newPass) {
    return this.handler.get(`${this.baseURL}/password/reset`, {
      data: {
        oldPass: oldPass,
        newPass: newPass
      }
    })
  }

  register(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}/signup/mobile`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(r)
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  verification(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}/signup/code`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                customer: UserService.parseUser(data.customer)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  registerFinalize(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}/signup`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(r)
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  editProfile(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .put(`${this.baseURL}/password`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                customer: UserService.parseUser(data.customer)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  deviceToken() {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`/api/v1/clients/register`, {
          // data: data,
          // params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                token: data.token
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  updatePushNotificationData(token) {
    return new Promise((resolve, reject) => {
      this.handler
        .put(`/api/v1/clients/notification-token`, {
            data: {
              notification_token: token,
            },
            params: {
              errorHandler: false
            }
          })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                token: data
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }
}

export default new AuthService()
